export const DARK_MODE: string = 'astrea-dark-mode';
